<template>
  <div class="blocheader-wrapper">
    <h1>{{ titre }}</h1>
    <div class="sub-section" :style="{ paddingTop: topSpace + 'px' }">
      <div class="toplegend-wrapper row justify-content-between">
        <h2 class="soustitre col-md-6">
          <font-awesome-icon :icon="icone" /> {{ sousTitre }}
        </h2>
        <div class="link-button-wrapper col-md-6 text-right">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    titre: {
      type: String,
      required: false
    },
    sousTitre: {
      type: String,
      required: false
    },
    icone: {
      type: Array,
      required: false
    },
    topSpace: {
      default: 0,
      type: Number,
      required: false
    }
  }
}
</script>
<style lang="scss">
$grey-700: #444444;
.blocheader-wrapper {
  h1 {
    font-family: "Open sans";
    font-size: 20px;
    font-weight: 600;
    color: $grey-700;
    text-transform: uppercase;
    margin-top: 35px;
  }
  .soustitre {
    font-family: "Open sans";
    font-size: 18px;
    color: #2b3085;
    font-weight: 600;
    padding-top: 10px;
    margin-bottom: 25px;
    line-height: 27px;
    svg {
      margin-right: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/utils/blocHeaderTitle.vue